import React from 'react';
import {Card, CardBody, CardTitle,} from 'reactstrap';

import RolePermissionForm from "./_form";
import RolePermissionList from "./_list";
import {ButtonCancel} from "../../../components/buttons/buttonsActions";

class RolePermission extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            role : this.props.role
        };

        this.refreshList = this.refreshList.bind(this);
        this.setForm = this.setForm.bind(this);

        this.refPermissionList = React.createRef();
    }

    async refreshList(){
        await this.refPermissionList.current.refreshList();
    }

    setForm(){
        this.props.setForm(false, false, undefined);
    }

    render() {

        return (
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-lock-open mr-2"/>
                    Permisos del rol
                </CardTitle>

                <RolePermissionForm role={this.state.role} refreshList={ this.refreshList } setForm={ this.setForm }/>

                <RolePermissionList role={this.state.role} ref={this.refPermissionList} />

                <CardBody className="border-top">
                    <div className="float-right">
                        <ButtonCancel onClick={this.props.setForm}/>
                    </div>
                </CardBody>

            </Card>
        )
    }

}

export default RolePermission;